/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import { Row } from 'react-bootstrap'
import { DraftContext, HelperContext } from '../components/ContextProvider'
import DragBar from '../components/DragBar'
import Label from './Label'
import TextArea from './TextAreaM1'
import CardTool from '../components/CardTool'
import { usePestelStore } from '../store'

const getFieldByLabel = (label) => {
  switch (label) {
    case 0:
      return 'politic'
    case 1:
      return 'economic'
    case 2:
      return 'social'
    case 3:
      return 'technology'
    case 4:
      return 'environment'
    case 5:
      return 'law'
    default:
      throw new Error('Invalid label')
  }
}

function Card({ setting }) {
  const {
    label,
    // content = false,
    labelEdit = () => {},
    textEdit = () => {},
    handleCardResort = () => {},
    addItem = () => {},
    removeItem = () => {},
    hideToolbar = true,
    regenerateItem = () => {},
  } = setting

  const {
    politic,
    economic,
    social,
    technology,
    environment,
    law,
    // updatePestelInfo,
  } = usePestelStore((store) => ({
    politic: store.politic,
    economic: store.economic,
    social: store.social,
    technology: store.technology,
    environment: store.environment,
    law: store.law,
    updatePestelInfo: store.updatePestelInfo,
  }))

  const content = useMemo(
    () => [politic, economic, social, technology, environment, law][label],
    [politic, economic, social, technology, environment, law, label]
  )

  const onDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    handleCardResort(
      label,
      content.pestel_info,
      result.source.index,
      result.destination.index
    )
  }

  // const textEdit = (value, itemIndex) => {
  //   setCards(
  //     cards.map((item, index) =>
  //       index === itemIndex ? [item[0], value] : item
  //     )
  //   )
  // }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="card-drop" direction="horizontal">
        {(dropProvided) => (
          <Row
            {...dropProvided.droppableProps}
            ref={dropProvided.innerRef}
            className="card-item-list"
          >
            {(content.pestel_info || []).map((item, itemIndex) => (
              <Draggable
                // key={`item-${itemIndex}`}
                key={item.id}
                draggableId={`draggable-${item.id}`}
                index={itemIndex}
              >
                {(dragProvided) => (
                  <div
                    ref={dragProvided.innerRef}
                    {...dragProvided.draggableProps}
                    {...dragProvided.dragHandleProps}
                    className="col column-item has-drag pb-5"
                  >
                    <DragBar />
                    <CardItem
                      setting={{
                        label,
                        item,
                        itemIndex,
                        addItem,
                        removeItem,
                        count: content.pestel_info.length,
                        labelEdit,
                        textEdit,
                        hideToolbar,
                        regenerateItem,
                      }}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {dropProvided.placeholder}
          </Row>
        )}
      </Droppable>
    </DragDropContext>
  )
}

function CardItem({ setting }) {
  const {
    label,
    item,
    itemIndex,
    addItem = () => {},
    removeItem = () => {},
    labelEdit = () => {},
    textEdit = () => {},
    // regenerateItem = () => {},
    count,
    hideToolbar = false,
  } = setting
  const { showWarn, setShowWarn, showGen, setShowGen } =
    useContext(DraftContext)
  const { sethelper } = useContext(HelperContext)
  // const [itemLoading, setItemLoading] = useState(item.loading)
  // useEffect(() => {
  //   setItemLoading(item.loading)
  // }, [item])

  const handleAdd = () => {
    // if (count < 4) {
    setShowGen({
      ...showGen,
      show: true,
      func: (value) => {
        addItem(itemIndex + 1, label, value)
      },
      placeholder: '例: 市場需求',
    })
    // }
  }

  const { getPestelSubById, updatePestelInfoById } = usePestelStore(
    (store) => ({
      updatePestelInfoById: store.updatePestelInfoById,
      getPestelSubById: store.getPestelSubById,
    })
  )

  // const handleRegenerate = (pestel_sub) => {
  //   console.log(pestel_sub)
  //   regenerateItem(label, itemIndex, pestel_sub)
  //   setItemLoading(true)
  // }
  // const [handleRegenerate, sethandleRegenerate] = useState(null)
  // console.log(handleRegenerate)

  // useEffect(() => {
  //   console.log('this is triggered')
  //   console.log(item.loading)
  //   if (!item.loading)
  //     sethandleRegenerate(() => () => {
  //       console.log(item.pestel_sub)
  //       regenerateItem(label, itemIndex, item.pestel_sub)
  //       setItemLoading(true)
  //     })
  // }, [item.loading])

  const handleDelete = () => {
    if (count > 1) {
      setShowWarn({
        ...showWarn,
        show: true,
        text: '確定刪除卡片？',
        func: () => {
          removeItem(label, itemIndex)
        },
      })
    }

    if (count === 1) {
      setShowWarn({
        ...showWarn,
        show: true,
        text: '最少一筆',
        func: () => {},
      })
    }
  }

  const { draftId } = useContext(DraftContext)
  const getPartialGenerate = async (value) => {
    const field = getFieldByLabel(label)
    const response = await fetch(
      `${window.location.protocol}/api/draft/${draftId}/data/pestel/${field}_partial_generation/partial`,
      {
        method: 'post',
        body: JSON.stringify({
          q: value,
        }),
        headers: {
          'content-type': 'application/json',
        },
      }
    )
    // if (!response.ok) {
    //   throw new Error(`Network response was not ok for ${url}`)
    // }
    // const contentType = response.headers.get('content-type')
    // if (!contentType || !contentType.includes('application/json')) {
    //   throw new TypeError(`Received non-JSON response from ${url}`)
    // }
    const json = await response.json()
    const target = json.pestel_info
      ? json.pestel_info.find(({ pestel_sub }) => pestel_sub === value) || {}
      : {}
    console.log(target)
    return {
      pestel: json.pestel,
      pestel_sub: value,
      content: target.content,
    }
  }

  const [contentState, setcontentState] = useState(item.content)
  useEffect(() => {
    setcontentState(item.content)
  }, [item.content])

  return (
    <>
      {hideToolbar && (
        <div className="card-tool">
          <CardTool
            setting={{
              handleAdd,
              // handleRegenerate,
              handleDelete,
            }}
          />
        </div>
      )}
      <div className="inner">
        <div className="card-label shadow-block">
          {item.loading && <Loading setting={{ style: 'one' }} />}
          <div className={`fade ${item.loading ? '' : 'show'}`}>
            <Label
              setting={{
                label,
                title: item.pestel_sub,
                itemIndex,
                labelEdit,
                edit: true,
              }}
            />
          </div>
        </div>
        <div className="card-item shadow-block p-0">
          {item.loading && <Loading setting={{ style: 'muti' }} />}
          <div className={`fade ${item.loading ? '' : 'show'}`}>
            <TextArea
              setting={{
                label,
                value: contentState,
                handleGettingAdvise: async () => {
                  const field = getFieldByLabel(label)
                  const sub = getPestelSubById(field, item.id)
                  sethelper({
                    show: true,
                    data: {
                      field,
                      sub,
                      value: contentState,
                    },
                    handleAccept: async (value) => {
                      await updatePestelInfoById(
                        field,
                        item.id,
                        'content',
                        value
                      )
                    },
                    history: [
                      {
                        created_on: moment(),
                        setting: {
                          from: 'gpt',
                          chat: '請輸入你想調整的關鍵字',
                        },
                      },
                    ],
                  })
                },
                handleRegenerate: async () => {
                  const field = getFieldByLabel(label)
                  const sub = getPestelSubById(field, item.id)
                  updatePestelInfoById(field, item.id, 'loading', true)
                  const generateData = await getPartialGenerate(sub)
                  // await updatePestelInfoById(
                  //   field,
                  //   item.id,
                  //   'pestel_sub',
                  //   generateData.pestel_sub
                  // )
                  await updatePestelInfoById(
                    field,
                    item.id,
                    'content',
                    generateData.content
                  )
                  await updatePestelInfoById(field, item.id, 'loading', false)
                  // regenerateItem(label, item.id, item.pestel_sub),
                },
                itemIndex,
                textEdit,
              }}
            />
          </div>
        </div>
      </div>
    </>
  )
}

function Loading({ setting }) {
  const { style } = setting

  if (style === 'one') {
    return (
      <div className="loading-wrap">
        <div className="loading-bar">loading</div>
      </div>
    )
  }

  return (
    <div className="loading-wrap">
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar mb-4">loading</div>
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar mb-4">loading</div>
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar">loading</div>
    </div>
  )
}

Loading.propTypes = {
  setting: PropTypes.shape().isRequired,
}

CardItem.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Card.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Card
